import { createSelector } from '@reduxjs/toolkit';
import { orderByPosition } from "../../../lib/utils";
export const clientEntriesSelector = ({
  clientEntries
}) => clientEntries;
export const loopClientEntriesSelector = createSelector(clientEntriesSelector, entries => entries.filter(entry => entry.parentGuid).sort(orderByPosition));
export const sheetClientEntriesSelector = createSelector(clientEntriesSelector, (state, sheetIds = []) => sheetIds, (clientEntries = [], sheetIds) => {
  return clientEntries.filter(({
    sheet_id
  }) => sheetIds.includes(sheet_id));
});